var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('theme-provider',{staticClass:"hyphens-auto font-sans font-light",attrs:{"theme":_vm.themeTailwind}},[_c('the-notification',{staticClass:"z-50 fixed bottom-12 inset-x-2 max-w-2xl mx-auto"}),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }